import { mapState } from 'pinia';
import { usePolarisStore } from '~/units/polaris/store';
import { ActivityTypes } from '~/units/polaris/constants';
import { useWebsiteStore } from '~/units/website/store';

export const ViewsMixin = defineNuxtComponent({
  props: {
    specificComponents: {
      required: false,
      default: () => [],
    },
  },

  computed: {
    ...mapState(useWebsiteStore, ['currentPage']),

    components() {
      if (this.specificComponents && Array.isArray(this.specificComponents) && this.specificComponents.length) {
        return this.specificComponents;
      }
      if (this.currentPage) {
        return this.currentPage.components;
      }
      return [];
    },
  },

  async mounted() {
    const polarisStore = usePolarisStore();
    const route = useRoute();

    const pageMeta = { ...useRoute().meta };
    await polarisStore.sendActivity(ActivityTypes.VISIT, {
      page_id: pageMeta?.pageId ? pageMeta.pageId.toString() : '',
      data: {
        route: {
          path: route.path,
          full_path: route.fullPath,
          name: route.name,
          params: route.params,
          query: route.query,
          redirected_from: route.redirectedFrom,
          meta: route.meta,
        },
      },
    });
  },
});
